var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-page"},[_c('h1',[_vm._v("Test")]),_c('div',{staticClass:"custom-page__content"},[_c('p',[_vm._v("Diese Testseite wurde überschrieben.")]),_c('TestComponent')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }